export default __webpack_public_path__ + "static/media/Destiny 9781408304730.92fb66ec.jpg";